<template>
  <header class="app-header">
    <div class="app-header-inner">
      <SiteLogo></SiteLogo>
      <div class="app-header-actions">
        <a :href="`tel:${market.phoneTel}`" class="app-header-phone">{{ market.phoneDisplay }}</a>
        <WaLink
          :source="pageContext.headerSource"
          class="app-header-wa"
          aria-label="Chat on WhatsApp"
        >
          <Icon name="whatsapp" :size="20" color="#0b141a"></Icon>
          <span class="app-header-wa-text">Chat on WhatsApp</span>
        </WaLink>
      </div>
    </div>
  </header>
</template>

<script>
import SiteLogo from "@/components/SiteLogo.vue";
import WaLink from "@/components/shell/WaLink.vue";
import Icon from "@/components/shell/Icon.vue";
import { market } from "@/utils/market";
import { pageContext } from "@/utils/pageContext";

// White header on every customer page: logo → website, phone number, and the
// green "Chat on WhatsApp" button (icon-only on phones).
export default {
  name: "AppHeader",
  components: { SiteLogo, WaLink, Icon },
  data: () => ({ market, pageContext }),
};
</script>

<style scoped>
.app-header {
  background: #fff;
  border-bottom: 1px solid #e3e7ea;
}
.app-header-inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
.app-header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 14px;
  font-weight: 600;
}
.app-header-phone {
  text-decoration: none;
  color: #1e1e1e !important;
  white-space: nowrap;
}
.app-header-wa {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #0b141a !important;
  background: #25d366;
  padding: 0 16px;
  height: 44px;
  border-radius: 5px;
  font-weight: 700;
  white-space: nowrap;
}
.app-header-wa:hover {
  background: #1ebe5a;
}
@media (max-width: 599px) {
  .app-header-inner {
    padding: 0 16px;
    height: 60px;
  }
  .app-header-phone,
  .app-header-wa-text {
    display: none;
  }
  .app-header-wa {
    width: 44px;
    padding: 0;
    justify-content: center;
  }
}
</style>
